import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBed: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bed"><path d="M4 7.75C4 5.67893 5.67893 4 7.75 4H11.25V9.5H4V7.75Z" fill="currentColor"/><path d="M12.75 9.5V4H16.25C18.3211 4 20 5.67893 20 7.75V9.5H12.75Z" fill="currentColor"/><path d="M22 14.75C22 12.6789 20.3211 11 18.25 11H5.75C3.67893 11 2 12.6789 2 14.75V16.25C2 17.2165 2.7835 18 3.75 18H4V19.25C4 19.6642 4.33579 20 4.75 20C5.16421 20 5.5 19.6642 5.5 19.25V18H18.5V19.25C18.5 19.6642 18.8358 20 19.25 20C19.6642 20 20 19.6642 20 19.25V18H20.25C21.2165 18 22 17.2165 22 16.25V14.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBed;
